import { createContext, useState } from 'react'

export const LanguageContext = createContext()

const LanguageProvider = ({ children }) => {
  
    const languageInLocal = localStorage.getItem('language') ? 
                            localStorage.getItem('language').toUpperCase() : 'ES';

    const [language, setLanguage] = useState(languageInLocal);

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageProvider
